import { Referral } from '../services/apiService';
import { normalizeRole } from './queueRole';

/** Reception queue bucket label for cross-queue search results (AXISREF350). */
export function getReceptionQueueBucket(referral: Referral, currentUserId: string): string {
  if (!referral.triage_approved) {
    return 'Yet to be Triaged';
  }
  if (referral.status === 'awaiting_reply') {
    return 'Awaiting Reply';
  }
  if (referral.assigned_to_user_id && referral.assigned_to_user_id === currentUserId) {
    return 'Assigned to Me';
  }
  if (!referral.assigned_to_user_id) {
    return 'Unassigned';
  }
  return 'Assigned';
}

/** Queue bucket for cross-queue search results; admin/manager see all queue tabs. */
export function getQueueBucket(
  referral: Referral,
  currentUserId: string,
  role?: string | null,
): string {
  const r = normalizeRole(role);
  if (r === 'admin' || r === 'manager' || r === 'viewer') {
    if (!referral.triage_approved) {
      return 'Yet to be Triaged';
    }
    if (referral.status === 'completed') {
      return 'Completed';
    }
    if (referral.is_escalated) {
      return 'Escalated';
    }
    if (referral.status === 'awaiting_reply') {
      return 'Awaiting Reply';
    }
    if (referral.ae_queue_entered_at) {
      return 'AE Validation';
    }
    if (referral.is_miscellaneous) {
      return 'Miscellaneous';
    }
    if (referral.assigned_to_user_id) {
      return 'Assigned';
    }
    return 'Unassigned';
  }
  return getReceptionQueueBucket(referral, currentUserId);
}

export function hasQueueSearchFilters(filters: {
  search?: string;
  referralType?: string[];
  funder?: string[];
  bodyPart?: string[];
  providerOrg?: string[];
  imagingFacility?: string[];
  providerName?: string[];
  assignee?: string;
  triageCategory?: number[];
  clinicNames?: string[];
}): boolean {
  if (filters.search?.trim()) {
    return true;
  }
  if (filters.assignee?.trim()) {
    return true;
  }
  if (filters.triageCategory && filters.triageCategory.length > 0) {
    return true;
  }
  const arrayKeys = [
    'referralType',
    'funder',
    'bodyPart',
    'providerOrg',
    'imagingFacility',
    'providerName',
    'clinicNames',
  ] as const;
  return arrayKeys.some((key) => (filters[key]?.length ?? 0) > 0);
}
